document.addEventListener('DOMContentLoaded', function() {
  // Handle trailing slash redirects before any other URL processing
  try {
    const path = window.location.pathname;
    // Only redirect if not homepage and has trailing slash
    if (path !== '/' && path.endsWith('/')) {
      const cleanPath = path.replace(/\/+$/, '');
      const newUrl = window.location.origin + cleanPath + window.location.search + window.location.hash;
      
      // Use history API first to avoid full page reload if possible
      window.history.replaceState({}, document.title, newUrl);
      
      // Force reload if history API didn't work
      if (window.location.pathname.endsWith('/')) {
        window.location.href = newUrl;
        return; // Stop further processing if redirecting
      }
    }
  } catch (slashError) {
    console.error('Error handling trailing slash:', slashError);
  }
  
  // Continue with the existing collection parameter logic
  try {
    // Check if we're on a collection page
    if (window.location.pathname.includes('/collections/')) {
      const pathParts = window.location.pathname.split('/collections/')[1].split('/');
      const collectionHandle = pathParts[0];
      
      if (collectionHandle) {
        // Add collection parameter to all product links
        const productLinks = document.querySelectorAll('a[href*="/products/"]');
        
        productLinks.forEach(link => {
          try {
            // Only process links that point to this store
            if (link.href.includes(window.location.hostname)) {
              const url = new URL(link.href);
              
              // Only add the parameter if it doesn't already exist
              if (!url.searchParams.has('collection')) {
                url.searchParams.set('collection', collectionHandle);
                link.href = url.toString();
              }
            }
          } catch (linkError) {
            console.error('Error processing link:', linkError);
          }
        });
      }
    }
    
    // Handle product pages - update breadcrumbs schema if collection parameter exists
    if (window.location.pathname.includes('/products/')) {
      const urlParams = new URLSearchParams(window.location.search);
      const collectionParam = urlParams.get('collection');
      
      if (collectionParam) {
        // Find the breadcrumbs schema
        const schemaScripts = document.querySelectorAll('script[type="application/ld+json"]');
        schemaScripts.forEach(script => {
          try {
            const schema = JSON.parse(script.textContent);
            
            // Check if this is the breadcrumbs schema
            if (schema && schema['@type'] === 'BreadcrumbList' && schema.itemListElement) {
              // Find the collection item (usually position 2)
              const collectionItem = schema.itemListElement.find(item => 
                item.position === 2 && item.item && item.item.includes('/collections/')
              );
              
              if (collectionItem) {
                // Update the collection in the breadcrumbs
                // We don't have the collection title here, so we'll use the handle with proper formatting
                const formattedTitle = collectionParam
                  .split('-')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ');
                
                collectionItem.name = formattedTitle;
                collectionItem.item = window.location.origin + '/collections/' + collectionParam;
                
                // Update the schema
                script.textContent = JSON.stringify(schema);
              }
            }
          } catch (schemaError) {
            console.error('Error processing schema script:', schemaError);
          }
        });
      }
    }
  } catch (error) {
    console.error('Error in collection parameter script:', error);
  }
});

// Also handle dynamic page changes (for AJAX navigation if your theme uses it)
document.addEventListener('page:loaded', function() {
  // Handle trailing slash for AJAX navigation
  try {
    const path = window.location.pathname;
    if (path !== '/' && path.endsWith('/')) {
      const cleanPath = path.replace(/\/+$/, '');
      const newUrl = window.location.origin + cleanPath + window.location.search + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
      
      // If history API didn't work, force reload
      if (window.location.pathname.endsWith('/')) {
        window.location.href = newUrl;
        return; // Stop further processing if redirecting
      }
    }
  } catch (slashError) {
    console.error('Error handling trailing slash in AJAX navigation:', slashError);
  }
  
  // Re-run the same logic for AJAX-loaded pages
  if (window.location.pathname.includes('/collections/')) {
    // Similar logic as above
    try {
      const collectionHandle = window.location.pathname.split('/collections/')[1].split('/')[0];
      document.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        if (!url.searchParams.has('collection')) {
          url.searchParams.set('collection', collectionHandle);
          link.href = url.toString();
        }
      });
    } catch (error) {
      console.error('Error in AJAX page handling:', error);
    }
  }
  
  // Also handle product pages in AJAX navigation
  if (window.location.pathname.includes('/products/')) {
    const urlParams = new URLSearchParams(window.location.search);
    const collectionParam = urlParams.get('collection');
    
    if (collectionParam) {
      // Update breadcrumbs schema for AJAX-loaded product pages
      const schemaScripts = document.querySelectorAll('script[type="application/ld+json"]');
      schemaScripts.forEach(script => {
        try {
          const schema = JSON.parse(script.textContent);
          if (schema && schema['@type'] === 'BreadcrumbList' && schema.itemListElement) {
            const collectionItem = schema.itemListElement.find(item => 
              item.position === 2 && item.item && item.item.includes('/collections/')
            );
            
            if (collectionItem) {
              const formattedTitle = collectionParam
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
              
              collectionItem.name = formattedTitle;
              collectionItem.item = window.location.origin + '/collections/' + collectionParam;
              script.textContent = JSON.stringify(schema);
            }
          }
        } catch (error) {
          console.error('Error updating breadcrumbs in AJAX navigation:', error);
        }
      });
    }
  }
});